class VracRecipev2 extends HTMLElement {
    constructor() {
        super();

        this.init();

    }

    init() {
        const swiper = new Swiper(this.querySelector('.swiper'), {
            // Optional parameters
            direction: 'horizontal',
            loop: false,
            slidesPerView: 'auto',

            pagination: {
                el: this.querySelector('.swiper-pagination'),
            },

            navigation: {
                nextEl: this.querySelector('.swiper-button-next'),
                prevEl: this.querySelector('.swiper-button-prev'),
            },
        });
    }
}

customElements.define('vrac-recipe-v2', VracRecipev2);